import { render } from "./instructor-header.vue?vue&type=template&id=16598275"
import script from "./instructor-header.vue?vue&type=script&lang=js"
export * from "./instructor-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__